import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { StatusBanner } from '@xing-com/banner';
import type {
  ApplicationData,
  ScreenOutCriteria,
} from '@xing-com/crate-jobs-helpers';
import { useApplicationStatusHelpers } from '@xing-com/crate-jobs-hooks';
import { spaceXXL } from '@xing-com/tokens';

type Props = ScreenOutCriteria & { application: ApplicationData };

const getCopyKey = (
  euWorkEligibility: boolean,
  languageSkillsGerman: boolean
): string | undefined => {
  if (euWorkEligibility && languageSkillsGerman) {
    return 'JOBS_JOB_DETAILS_FULL_REQUIREMENTS';
  }
  if (euWorkEligibility) {
    return 'JOBS_JOB_DETAILS_WORK_PERMIT_REQUIREMENT';
  }
  if (languageSkillsGerman) {
    return 'JOBS_JOB_DETAILS_GERMAN_PROFICIENCY_REQUIREMENT';
  }

  return undefined;
};

export const RequirementsBanner: FC<Props> = ({
  euWorkEligibility = false,
  languageSkillsGerman = false,
  application,
}) => {
  const { appliedAt } = useApplicationStatusHelpers(application);
  const copyKey = getCopyKey(euWorkEligibility, languageSkillsGerman);

  if (!copyKey || !!appliedAt) return null;

  return (
    <Banner display="inline">
      <FormattedMessage id={copyKey} />
    </Banner>
  );
};

const Banner = styled(StatusBanner).attrs({ variant: 'info' })`
  margin-top: ${spaceXXL};
`;
